import { createApp } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import './assets/font/font.css';


import App from './App.vue'
import router from './router'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  createApp(App).component(key, component)
}
createApp(App).use(router).use(ElementPlus).mount('#app')

